import { Route, Switch } from 'react-router';
import React from 'react';
import AdminShortcuts from './AdminShortcuts';
import PostpaidServices from './PostpaidServices';
import AdminOnTheGoNewServices from './AdminOnTheGoNewServices';
import AuthHOC from 'layouts/AuthHOC';
import { AuthConsumer } from 'components/Auth/authContext';

interface IServicesProps {
	match: {
		path: string;
	};
}

const AdminMain = ({ match }: IServicesProps) => {
	return (
		<>
			<Switch>
				<Route path={match.path} exact render={(props: any) => <AdminShortcuts {...props} />} />
				<Route
					path={`${match.path}/postpaid-services/:accountNum/:bAccountId/:accountType(MOBILE|FIX|INTERNET)/:billingType(POSTPAID|PREPAID)/:upAccountId/:accountId`}
					render={(props: any) => <PostpaidServices {...props} />}
				/>
				<Route
					path={`${match.path}/admin-on-the-go-new-services/:accountId`}
					render={(props: any) => <AdminOnTheGoNewServices {...props} />}
				/>
			</Switch>
		</>
	);
};

const AdminCon = (props: any) => {
	return <AuthConsumer>{({ user }) => <AdminMain userType={user.userType} {...props} />}</AuthConsumer>;
};

export default AuthHOC(AdminCon);
